const bscTestnetAddresses = {
  TRAVA_TOKEN_ADDRESS: "0x4abef176f22b9a71b45ddc6c4a115095d8761b37",
  BUSD_TOKEN_ADDRESS: "0x8ADE9A293528EB21f2fD9d7fF6eD919Adf1AdEC7",
  RENT_CONTRACT_ADDRESS: "0x8B5B5ac9edc23C1f946d72b74E0eB2D7f6dA36E4",
  KAWAII_CORE_ADDRESS: "0xc12eD27AA3d3A20d7474518a9bB3587EcEE367E3",
  KAWAII_PROXY_CONTRACT_ADDRESS: "0xbc5360e48D8c912E9955caFD7E599645f12104B0",
  MULTI_CALL_ADDRESS: "0xd808400FbF312ACA5C7487cd30B0D1386e04BC78",
  TOKEN_FAUCET_ADDRESS: "0x7B2E3267099f7CB93353cE146Eb22AcEFb02c3Eb",
  TRAVA_AIRDROP_ADDRESS: "",
  KAWAII_AIRDROP_ADDRESS: "",
  KAWAII_TOKEN_ADDRESS: "",

  NFT_CORE_ADDRESS: "0xd2Eca5a421db7c2e2aC88Da684214B52915A66b3",
  NFT_MANAGER_ADDRESS: "0xA91A365D2e3D280553E96D5afA157e6A3e50890A",
  NFT_COLLECTION_ADDRESS: "0x5D996eC57756cEB127a4eD3302d7F28F52FDEbb1",
  NFT_SELL_ADDRESS: "0x6C5844D1681C346c0f95669B1efe394ef12F1B93",
  NFT_BUY_ADDRESS: "0x105ED6BFdeB0af864714c09cFaD776eB39001e7D",
  NFT_SELL_COLLECTION_ADDRESS: "0xfF4F3a425808af7759E420cf0fB78c0Ed94Cf19b",
  GIVEAWAY_ADDRESS: "0xc76c614c2Ebc3187860F7BcE2c02739C68b84424",
  NFT_TRANSMUTATION_ADDRESS: "0xC02624a76B634518E6F35384aA74b025d12099f2",
  NFT_AUCTION_ADDRESS: "0xD3DEba29db83A4Be4A3635d20e3FAe791298086C",
  FLASH_SALE_ADDRESS: "0x86150655aA7fee5804b15311b8436e687913AbCF",
  BATTLE_HAND_ADDRESS: "0xfa2fab27eB9893a5B16D231D989ADa32aB0609f1",
  NFT_FARMING_BASE_EXP: "0x21541E88F82986caA2E7a531F35520c6b736df35",
  STAKING_R_TRAVA_ADDRESS: "0x17b173D4B80B0B5BB7E0f1E99F5962f2D51799Eb",
  VE_TRAVA_ADDRESS: "0x7E41803de7781f53D1901A3d70A3D3747b3B3B63",
  TRAVA_VE_TOKEN_ADDRESS: "0xCE9f0487f07988003f511d6651153a6dacC32f50",
  RTRAVA_VE_TOKEN_ADDRESS: "0x4a9901cdAfDFB2aC614c12627E0A5B45A63929d6",
  VE_TRAVA_MARKETPLACE_ADDRESS: "0x642e9fD16cA66db2747695dc0DddD0ce54aB3AB1",

  NFT_TICKET: "0x858D0cfa0743Ff1Ccc4970A432D661887AA7892f",
  NFT_TICKET_MANAGER: "0x5c362e4626f8Ab946cA700Fd3122CAEc8aB7b5F8",
  NFT_TICKET_MARKETPLACE: "0xff40C3e60578ebf1f9cA218020bf3DD332063C80",
  NFT_TICKET_COUNTER: "0x49FD2B213a99c2754cE76D07eCb3016134E2AC5C",
  NFT_TICKET_STAKING: "0x74Abf9ACba9ADbb3C0500661B17FC1eb046719a2",
  USDT_TEST: "0x4c4c515570A9072bb6191e1Db79292E22FABF4bB",
  BOX_SALE: "0xeAEb48447B4C33694E8620dd7f52C34444038A70",

  MAIN_GATE: "0x1dB36afdEFdA5C95c68E3Fc6C394116ba637491E",
  MAIN_BRIDGE: "0xF1162c85eb69d44380eb9a17bD373aE818a8D5d4",
  MAIN_CANONICAL_TRANSACTION_CHAIN: "0xc7a74E04Cabe987abE111aBa1F10e05634823ABc",
  SIDE_CANONICAL_TRANSACTION_CHAIN: "0xaE2b14edd209d2Ac86C52e47c27226a20fEeF846",
  MAIN_TRANSACTOR: "0x6c8803235750717e839DA27b4070313e3794C9a8",
  SIDE_MULTI_CALL: "0x7e2698C18caC3789e45ab584419f2AcF3ABf9218",
  SIDE_TRANSACTOR: "0x743D0A0ca19b386BEa322dc7e06D5f64a5481f0c",
  SIDE_COLLECTION: "0xD6663F97973a70169e25e34713af7B7E5375ac4a",
  SIDE_TOKEN: "0x6B9Ef55bc9973Ab168564DBa1CE8455487B3E81a",
  SIDE_BRIDGE: "0xCa11Ef2354f3FbB99217E993F3c14EdDAA346FC1",
  FAKE_NFT_COLLECTION: "0x15f9739e8752efDf2C1653713831237e633fbd71",
  PANCAKE_ROUTER: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
  NFT_TICKET_COIN: "0xDD8b8cf9CE1e16D5070E122df774CA4ADB654b50",
  PANCAKE_PAIR: "0xdef1d8e60495e82ca8063dc4e900e5bbbacb7e8c",
  NFT_DEX: "0xB415326644C6DB704E82cD9feFb8cc5efD112624",

  DILUTION_STAKING: "0xC51cfa3D6F03B0dd91BE1650C769443c2c3875f2",
  TRAVA_DILUTION_COIN: "0x2F23ED448aC290741AecE24Cb92D23ebAFfABA43",
};

export default bscTestnetAddresses;
